export default "__VITE_ASSET__CSXMCSRT__"